import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_x43w5mndhf: FaireCollectionEntity = {
  token: "pbc_x43w5mndhf",
  type: "collection",
  name: "Spring Sports⛳⚾",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8136c67d70507fe34a3089d9df51ea1129218a099f1453dba794e5be1106bb8c.jpeg",
  itemCount: 23,
  description:
    "Tee off in style with playful, polished pieces made for little golfers on the move. From course-ready classics to cute coordinating looks, this collection brings all the charm for every swing, stroll, and celebration on the green!",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:39.180Z",
    importedBy: "entity-db-import-collections",
  },
};
